module.exports = __webpack_public_path__ + "static/media/pdtvid2.540da35c.svg";